/* eslint-disable react-hooks/exhaustive-deps */
import { toArray } from 'lodash';
import { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import useDataTable from '../../../hooks/useDataTable';
import { useDonation } from './ContextAPI';

export default function DrugTable({ drugList }) {
    const { donateData, setDonateData, setDonateList, rowData, setRowData, setRowDataList } =
        useDonation();

    const tableStyle = {
        paddingLeft: '5px',
        paddingRight: '5px',
    };

    const cellStyle = {
        minWidth: '150px',
        maxWidth: '150px',
        lineHeight: '33px',
    };

    const getRowKey = (row) => row.drug_id || row.id || row.drug_name;

    const getBatchKey = (row, item, index) =>
        [
            getRowKey(row),
            item.stockin_id || item.id || item.stock_id || item.batch_id || item.batch_no,
            item.batch_no,
            item.expire_date,
            index,
        ]
            .filter((el) => el !== undefined && el !== null)
            .join('_');

    const getCleanBatch = (item) => {
        const { donation_qty, ...batchInfo } = item;
        return batchInfo;
    };

    const getDonationQty = (row, index) =>
        rowData?.[getRowKey(row)]?.batch_info?.[index]?.donation_qty;

    const donateHandler = (value, item, row, batchIndex) => {
        const rowKey = getRowKey(row);
        const batchKey = getBatchKey(row, item, batchIndex);

        setDonateData((previousDonateData) => {
            const list = { ...previousDonateData };
            if (value === '') {
                delete list[batchKey];
            } else {
                list[batchKey] = {
                    ...item,
                    donation_qty: value,
                };
            }
            return list;
        });

        setRowData((previousRowData) => {
            const rlist = { ...previousRowData };
            const existingRowData = rlist[rowKey];
            const batchInfo = row.batch_info?.map((el, index) => {
                const currentBatchKey = getBatchKey(row, el, index);
                const existingDonationQty =
                    existingRowData?.batch_info?.[index]?.donation_qty;
                const nextDonationQty =
                    currentBatchKey === batchKey ? value : existingDonationQty;

                if (
                    nextDonationQty === '' ||
                    nextDonationQty === undefined ||
                    nextDonationQty === null
                ) {
                    return getCleanBatch(el);
                }

                return {
                    ...getCleanBatch(el),
                    donation_qty: nextDonationQty,
                };
            });

            const hasDonationQty = batchInfo?.some(
                (el) =>
                    el.donation_qty !== '' &&
                    el.donation_qty !== undefined &&
                    el.donation_qty !== null
            );

            if (hasDonationQty) {
                rlist[rowKey] = {
                    ...row,
                    batch_info: batchInfo,
                };
            } else {
                delete rlist[rowKey];
            }
            return rlist;
        });
    };

    // Object to Array Convart
    useEffect(() => {
        const arrOfObj = toArray(donateData);
        setDonateList(arrOfObj);
    }, [donateData]);

    // Object to Array Convart
    useEffect(() => {
        const arrOfObj = toArray(rowData);
        setRowDataList(arrOfObj);
    }, [rowData]);

    function ItemTitle() {
        return <span className="ps-2">Item Name</span>;
    }

    function Title() {
        return (
            <table className="table table-bordered mb-0 text-center" style={tableStyle}>
                <thead>
                    <tr>
                        <th className="m-0" style={cellStyle}>
                            Batch No
                        </th>

                        <th className="m-0" style={cellStyle}>
                            Expire Date
                        </th>

                        <th className="m-0" style={cellStyle}>
                            Available QTY
                        </th>

                        <th className="m-0" style={cellStyle}>
                            Month Consumption
                        </th>

                        <th className="m-0" style={cellStyle}>
                            10% Consumption
                        </th>

                        <th className="m-0" style={cellStyle}>
                            Donate Qty
                        </th>
                    </tr>
                </thead>
            </table>
        );
    }

    const columns = [
        {
            name: <ItemTitle />,
            cell: (row) => <span className="ps-2">{row.drug_name}</span>,
            sortable: true,
            wrap: true,
            width: '250px',
            fixed: true,
        },
        {
            name: <Title />,
            cell: (row) => (
                <table className="table table-bordered mb-0 text-center" style={tableStyle}>
                    <tbody>
                        <tr style={{ borderTopWidth: '0px' }}>
                            <td style={cellStyle}>
                                {row.batch_info.map((el, index) => (
                                    <p key={getBatchKey(row, el, index)}>{el.batch_no}</p>
                                ))}
                            </td>
                            <td style={cellStyle}>
                                {row.batch_info.map((el, index) => (
                                    <p key={getBatchKey(row, el, index)}>{el.expire_date}</p>
                                ))}
                            </td>
                            <td style={cellStyle}>
                                {row.batch_info.map((el, index) => (
                                    <p key={getBatchKey(row, el, index)}>{el.available_qty}</p>
                                ))}
                            </td>
                            <td style={cellStyle}>{row.consumption_info?.consumption_ratio}</td>
                            <td style={cellStyle}>
                                {row.consumption_info?.consumption_percentage}
                            </td>
                            <td style={cellStyle}>
                                {row.batch_info?.map((el, index) => (
                                    <div key={getBatchKey(row, el, index)}>
                                        <Form.Control
                                            size="sm"
                                            readOnly={el.available_qty === 0}
                                            type="number"
                                            value={
                                                getDonationQty(row, index) !== undefined &&
                                                getDonationQty(row, index) !== null
                                                    ? getDonationQty(row, index)
                                                    : ''
                                            }
                                            onChange={(e) => {
                                                donateHandler(e.target.value, el, row, index);
                                            }}
                                        />
                                        <br />
                                    </div>
                                ))}
                            </td>
                        </tr>
                    </tbody>
                </table>
            ),
        },
    ];

    const search_column = { drug_name: 'Item Name', 'batch_info.batch_no': 'Batch No' };
    return useDataTable({
        columns,
        data: drugList,
        search_column,
        pagination: false,
        cellPadding: '0px',
        borderWidth: '0px',
        keyField: 'drug_id',
    });
}
